import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";
import VueMeta from "vue-meta";
// var express = require('express'); // Get the module
// var app = express(); // Create express by calling the prototype in var express
// import { response } from 'express';

Vue.use(Vuex);
Vue.use(VueMeta);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    profile,
  },
});
// app.use(express.static(__dirname));

// app.get("/*", function(req, res) {
//   res.sendFile(path.join(__dirname, "index.html"));
// });
